import * as React from 'react';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import ImageReserveCoaching from './images/reserve_coaching.png';

type Props = {
  page_key: UserTutorialCompletionKey;
};

export const UserTutorialDetailSource = ({ page_key }: Props) => {
  switch (page_key) {
    case UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE:
      return null;
    case UserTutorialCompletionKey.KEY_JOIN_SLACK:
      return null;
    case UserTutorialCompletionKey.KEY_START_COURSE:
      return null;
    case UserTutorialCompletionKey.KEY_ATTEND_WELCOME_WORKSHOP:
      return <img src={ImageReserveCoaching} />;
    default:
      return null;
  }
};
